import { useEffect, useState } from 'react';

const MOBILE_MOTION_QUERY = '(max-width: 680px)';

export function useMobileLightMotion() {
  const [isMobile, setIsMobile] = useState(() =>
    typeof window === 'undefined' ? false : window.matchMedia(MOBILE_MOTION_QUERY).matches
  );

  useEffect(() => {
    const media = window.matchMedia(MOBILE_MOTION_QUERY);
    const handleChange = () => setIsMobile(media.matches);

    handleChange();
    media.addEventListener('change', handleChange);
    return () => media.removeEventListener('change', handleChange);
  }, []);

  return isMobile;
}
